import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CreateAccountCommand } from '../commands/accounts/create.account.command';
import { ApiService } from '../common/services/api.service';
import { Account } from '../models/admin/account';
import { SerpConfig } from '../models/admin/serp.config';
import { SpiderPage } from '../components/admin/accounts/event.spider/event.spider.modal.component';

@Injectable()
export class SchedulerApiService {
  constructor(private apiService: ApiService) {}

  public synceAll(source: string): Observable<void> {
    return this.apiService.post(`scheduler/sync-all?source=${source}`);
  }

  public synceOne(hubName: string, source: string, from = 0, to = 1000): Observable<void> {
    return this.apiService.post(`scheduler/sync-one?hubName=${hubName}&source=${source}&from=${from}&to=${to}`);
  }

  public updatePlaces(hubName: string, from, to): Observable<void> {
    return this.apiService.post(`scheduler/update-places?hubName=${hubName}&from=${from}&to=${to}`);
  }

  public runEventbriteConjob(isUseCityCode: boolean, isUseCityCodeAPIOnEventbriteHomepage: boolean): Observable<void> {
    return this.apiService.post(`scheduler/eventbrite-api-events-cronjob`, {
      isUseCityCode,
      isUseCityCodeAPIOnEventbriteHomepage,
    });
  }

  public tagPlaceImageAvailability(hubName: string, from, to): Observable<any> {
    return this.apiService.post(`scheduler/tag-place-image-availability?hubName=${hubName}&from=${from}&to=${to}`);
  }
  public eventPullingStatus(): Observable<any[]> {
    return this.apiService.post(`scheduler/event-pulling-status`);
  }

  public updatePlaceByFBId(id: string, hubName: string, token?: string): Observable<void> {
    return this.apiService.post(`scheduler/update-place-by-id?id=${id}&hubName=${hubName}token=${token}`);
  }

  public deleteOutDatedEvents(): Observable<void> {
    return this.apiService.post(`scheduler/outdated-events`);
  }

  public updateMultiDateEvents(): Observable<void> {
    return this.apiService.post(`scheduler/update-multi-date-events`);
  }

  public getLatAndLngFromGoogleForMissingAddressEvents(hubName): Observable<void> {
    return this.apiService.post(`scheduler/get-missing-address?hubName=${hubName}`);
  }

  public updatEventImages(hubName): Observable<void> {
    return this.apiService.post(`scheduler/update-event-images?hubName=${hubName}`);
  }

  public removeDuplicatedPlaces(): Observable<void> {
    return this.apiService.post(`scheduler/remove-duplicated-places`);
  }

  public updatePlacesForNext(): Observable<void> {
    return this.apiService.post(`scheduler/update-places-for-next`);
  }

  public filterUnofficialPlaces(hubName: string): Observable<void> {
    return this.apiService.post(`scheduler/filter-unofficial-places?hubName=${hubName}`);
  }

  public getTravelBuddyConversationClientAggregation(): Observable<any> {
    return this.apiService.get(`scheduler/travel-buddy-conversation-client-aggregation`);
  }
  public getTravelBuddyConversationUserAggregation(hubName: string): Observable<any> {
    return this.apiService.get(`scheduler/travel-buddy-conversation-user-aggregation?hubName=${hubName}`);
  }
  public getTravelBuddyConversationByUser(hubName: string, userId: string): Observable<any> {
    return this.apiService.get(`scheduler/travel-buddy-conversation-by-user?hubName=${hubName}&userId=${userId}`);
  }

  public spiderLink(link, socialName, isUseProxy, accountName): Observable<any[]> {
    return this.apiService.post(`scheduler/spider-link`, { link, socialName, isUseProxy, accountName });
  }

  public serpApi(
    accountName: string,
    city: string,
    serpConfig: SerpConfig
  ): Observable<{ success: boolean; msg: string; events: any[] }> {
    return this.apiService.post(`scheduler/serp-api-events`, { city, serpConfig, accountName });
  }

  public eventbriteApi(
    accountName: string,
    page: SpiderPage
  ): Observable<{ success: boolean; msg: string; events: any[] }> {
    return this.apiService.post(`scheduler/eventbrite-api-events`, { accountName, page });
  }
  public eventbriteEventDetails(url: string): Observable<any> {
    return this.apiService.post(`scheduler/eventbrite-event-details`, { url });
  }

  public checkSerpStatus(): Observable<{ isPulling: boolean }> {
    return this.apiService.get(`scheduler/check-serp-status`);
  }

  public getSpiderPulledEvents(socialName: string): Observable<any[]> {
    return this.apiService.get(`scheduler/spider-pulled-events?socialName=${socialName}`);
  }

  public stopPullingEvents(): Observable<any[]> {
    return this.apiService.get(`scheduler/stop-pulling-events`);
  }

  public setSpiderPageConfig(url: string, tag: string, socialName: string): Observable<any[]> {
    return this.apiService.post(`scheduler/spider-page-config`, { socialName, url, tag });
  }

  public updatePlaceCover(): Observable<any[]> {
    return this.apiService.post(`scheduler/set-place-cover`);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/scheduler.api.service.ts